module.exports = __webpack_public_path__ + "img/732-d6a71f.png";